import { Component } from '@angular/core';
import { membersuiteMerchandiseEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Merchandises') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitemerchandise-form',
    templateUrl: './membersuitemerchandise.form.component.html'
})
export class membersuiteMerchandiseFormComponent extends BaseFormComponent {
    public record!: membersuiteMerchandiseEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

